export default function Main({ children }) {
    return <main className="main-container container-fluid">{children}</main>;
}
